import * as React from 'react';

import {Body} from 'shells/typography/body';

import type {GetActivities_activities as Activity} from 'nutshell-graphql-types';

type Props = {
    activity: Activity;
    width: number;
};

export function Participants(props: Props) {
    if (props.activity.participants.length === 0) {
        return null;
    }

    const mainParticipant = props.activity.participants[0];
    const otherParticipants = props.activity.participants.slice(1, 4);

    return (
        <>
            <Body nowrap={true} size='small'>
                {/* @ts-expect-error */}
                {mainParticipant.name}
            </Body>
            {otherParticipants.length > 0 && (
                <Body nowrap={true} color='light' size='mini'>
                    {props.width && props.width < 700
                        ? `+ ${props.activity.participants.length - 1} more`
                        : otherParticipants.map((p) => p.name).join(', ')}
                </Body>
            )}
        </>
    );
}
